import MineDamageLogic from "../../../logic/MineDamageLogic";
import { Settings } from "../../../Settings";
import NumberFormatter from "../../../util/NumberFormatter";
import Totals from "../../crew/Totals";
import Values from "../../value/Values";
import SkillNode from "../SkillNode";

export default class DepthBonusSkillNode extends SkillNode {
    /**
     * @param {string} id 
     * @param {string} description 
     * @param {Totals} totals
     * @param {string} iconFileName 
     * @param {BigNum} cost 
     * @param {Values} values
     * @param {MineDamageLogic} mineDamageLogic
     * @param {number} purchaseIndex Starts at 0
     */
    constructor(id, totals, iconFileName, cost, purchaseListener, values, mineDamageLogic, purchaseIndex) {
        super(id, 'Depth Damage +' + NumberFormatter.formatNumber(Settings.depth.baseBonusPerUpgrade + (Settings.depth.incrementBonusPerUpgrade * purchaseIndex)), null, totals, 
            iconFileName, cost, purchaseListener);

        /**
         * @constant
         * @type {Values}
         */
        this.values = values;
        /**
         * @constant
         * @type {MineDamageLogic}
         */
        this.mineDamageLogic = mineDamageLogic;
        /**
         * @constant
         * @type {number}
         */
        this.purchaseIndex = purchaseIndex;
    }

    /**
     * @returns {string}
     */
    getDescription() {
        const bonusMultiplier = this.values.skillDepthBonusMultiplier.getValue();
        if (bonusMultiplier === 0) {
            return 'Damage / Max Depth: 0';
        }
        else {
            return 'Damage / Max Depth: x' + NumberFormatter.formatNumber(bonusMultiplier);
        }
    }

    /**
     * @override
     */
    onPurchase() {
        if (super.onPurchase()) {
            this.applyUpgrade();
            this.mineDamageLogic.calculateTotalMineDamagePerTurn();
            return true;
        }
        else {
            return false;
        }
    }

    /**
     * @override
     */
    onPurchaseFromSave() {
        this.applyUpgrade();
        super.onPurchaseFromSave();
    }

    /**
     * @private
     */
    applyUpgrade() {
        const bonus = Settings.depth.baseBonusPerUpgrade + (Settings.depth.incrementBonusPerUpgrade * this.purchaseIndex);
        this.values.skillDepthBonusMultiplier.incrementValue(bonus);
    }
}